<template>
    <div class="content new-booking">
        <iframe ref="bookingWidget" title="Booking widget" :src="checkoutUrl" v-if="checkoutUrl" scrolling="auto" id="new-booking-iframe" width="100%" height="100%"></iframe>
    </div>
</template>

<script>
    import {Api} from '../../../api';
    import {AppModel} from '../../../models';
    import {EventBus} from '../../../utils';

    const CHECKOUT_URL = process.env.CHECKOUT_URL || 'http://localhost:5173';

    export default {
        name: 'booking-new',

        created() {
            this.setCheckoutUrl();
            EventBus.$on(EventBus.BOOTSTRAP_DONE, this.setCheckoutUrl);
            window.addEventListener('message', this.onWidgetMessage);
        },

        beforeDestroy() {
            EventBus.$off(EventBus.BOOTSTRAP_DONE, this.setCheckoutUrl);
            window.removeEventListener('message', this.onWidgetMessage);
        },

        data() {
            return {
                checkoutUrl: '',
            };
        },

        methods: {
            setCheckoutUrl() {
                if(AppModel.activeCampground) {
                    this.checkoutUrl = CHECKOUT_URL.replace(/\/$/, '') + '/' + this.$route.params.lang + '/' + encodeURIComponent(AppModel.activeCampground.slug) + '/?mcadmin=1';
                }
            },

            onWidgetMessage(event) {
                const iframe = this.$refs.bookingWidget;
                if(!iframe || event.source !== iframe.contentWindow || event.origin !== new URL(this.checkoutUrl).origin || !event.data) return;

                if(event.data.type === 'campnerd.ready') {
                    iframe.contentWindow.postMessage({
                        type: 'campnerd.init',
                        config: {token: Api.user.getToken(), demoMode: false},
                    }, event.origin);
                } else if(event.data.type === 'campnerd.booking-created') {
                    this.onBookingCreated();
                } else if(event.data.type === 'campnerd.back-to-bookings') {
                    this.onBookingCreatedBack();
                }
            },

            onBookingCreated() {
                window.scrollTo(0, 0);
            },

            onBookingCreatedBack() {
                this.$router.push({name: 'bookings'});
            },
        },
    };
</script>

<style lang="scss">
    @import 'booking-new.scss';
</style>



// WEBPACK FOOTER //
// src/views/pages/booking-new/bookingNew.vue